import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Layout from '../components/Layout';

const Dashboard = () => {
  const { user } = useContext(AuthContext);

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-3xl font-bold text-ik-black mb-8">
            Witaj, {user?.first_name || user?.email}!
          </h1>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            <Link
              to="/chimneys"
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition border-2 border-transparent hover:border-ik-orange"
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-ik-orange rounded-lg flex items-center justify-center mr-4">
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <h2 className="text-xl font-semibold text-ik-black">
                  Kominiarze
                </h2>
              </div>
              <p className="text-gray-600">
                Przeglądaj listę dostępnych kominiarzy w Twojej okolicy
              </p>
            </Link>

            <Link
              to="/appointments"
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition border-2 border-transparent hover:border-ik-orange"
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-ik-orange rounded-lg flex items-center justify-center mr-4">
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h2 className="text-xl font-semibold text-ik-black">Wizyty</h2>
              </div>
              <p className="text-gray-600">
                Zarządzaj swoimi umówionymi wizytami
              </p>
            </Link>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gray-400 rounded-lg flex items-center justify-center mr-4">
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h2 className="text-xl font-semibold text-ik-black">Opinie</h2>
              </div>
              <p className="text-gray-600">
                Twoje opinie o kominiarzach
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-semibold text-ik-black mb-4">
              Szybkie akcje
            </h2>
            <div className="space-y-3">
              <Link
                to="/chimneys"
                className="block w-full px-4 py-3 bg-ik-orange text-white rounded-lg hover:bg-orange-600 transition text-center font-semibold"
              >
                Znajdź kominiarza
              </Link>
              <Link
                to="/appointments"
                className="block w-full px-4 py-3 border-2 border-ik-orange text-ik-orange rounded-lg hover:bg-ik-orange hover:text-white transition text-center font-semibold"
              >
                Moje wizyty
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
